import { isNotNullOrUndef } from '../../js/helpers/isNotNullOrUndef';
import { getLazyLinkToImage } from '../../js/helpers/getLazyLinkToImage';
const vNode = window.vNode;
export const createImage = ({ hit, title, urls, sizes = '', keywords, clickCallback, artImage = false, image3D = false }) => {
    let altString = '';
    let productLink = urls?.link ?? hit.url;
    if (urls !== undefined && isNotNullOrUndef(urls.selectedLayout)) {
        try {
            const SEOKeyword1 = keywords?.kw1 ?? '';
            let layoutName;
            switch (urls.selectedLayout.type) {
                case 'Canvas':
                    layoutName = '1 piece';
                    break;
                case 'Multiple':
                    layoutName = `${urls.selectedLayout.pieces} pieces`;
                    productLink = productLink.substring(0, productLink.lastIndexOf('?'));
                    break;
                default:
                    layoutName = urls.selectedLayout.type;
            }
            altString = `${layoutName} ${title} ${SEOKeyword1}`;
            if (isNotNullOrUndef(urls.previewImage)) {
                if (isNotNullOrUndef(urls.previewImage.room_type)) {
                    altString += ` on a ${urls.previewImage.room_type} wall.`;
                }
                if (isNotNullOrUndef(urls.previewImage.colors)) {
                    altString += ` With ${urls.previewImage.colors.join(', ')} color tones`;
                }
            }
        }
        catch (e) {
            console.log('Error generating alt for image', e);
        }
    }
    const imageSrc = artImage
        ? hit.square_image
        : image3D && urls?.selectedLayout.preview_3d !== undefined && urls.selectedLayout.preview_3d.length > 0
            ? urls.selectedLayout.preview_3d
            : urls?.previewImage?.url ?? hit.main_image;
    const lazySrc = getLazyLinkToImage(imageSrc);
    return vNode.create('div', { class: 'alg__result-item_image bdrs:2 ov:h' }, [
        vNode.create('a', {
            href: productLink,
            class: 'd:block image-wrapper',
            'aria-describedby': 'adb_open adb_word-product',
            ...(isNotNullOrUndef(clickCallback) && { events: { click: clickCallback } })
        }, [
            vNode.create('img', {
                ...(image3D ? { style: 'background-color: #f2f3f4' } : { class: 'skeleton' }),
                src: imageSrc,
                srcset: [180, 360, 540, 720, 900, 1080, 1200].map(width => `${lazySrc.replace('{width}', width.toString())} ${width}w`).join(', '),
                loading: 'lazy',
                height: 1200,
                width: 1200,
                sizes,
                alt: altString
            })
        ])
    ]);
};
